import { web3 } from 'fbonds-core'

export const KYSOL_MINT = new web3.PublicKey('kySo1nETpsZE2NWe5vj2C64mPSciH1SppmHb4XieQ7B')
export const JITOSOL_MINT = new web3.PublicKey('J1toso1uCk3RLmjorhTtrVwY9HJ7X8V9yYac6Y7kGCPn')
export const JITO_STAKE_POOL = new web3.PublicKey('Jito4APyf642JPZPx3hGc6WWJ8zPKtRbRs4P815Awbb')
export const KYSOL_MINT_SLIPPAGE_BPS = 100

export { createKySolLeverageTxnData } from './createKySolLeverageTxnData'
